export default function (baseCost, contactCost, kind) {
  if (_.includes(['sms_survey', 'phone'], kind)) {
    return parseFloat(baseCost + (contactCost * 0.5))
  } else {
    return parseFloat(baseCost + contactCost)
  }
};
